import * as types from './ReviewsTypes'

// GET ALL
export const getReviewsAction = () => ({ type: types.GET_ALL_REVIEWS })
export const getReviewsPendingAction = () => ({ type: types.FETCH_ALL_REVIEWS_PENDING })
export const getReviewsFulfilledAction = reviews => ({
  type: types.FETCH_ALL_REVIEWS_FULFILLED,
  payload: { reviews },
}) // eslint-disable-line
export const getReviewsRejectedAction = error => ({ type: types.FETCH_ALL_REVIEWS_REJECTED, error }) // eslint-disable-line

export const getReviewsByStatusAction = status => ({ type: types.GET_REVIEWS_BY_STATUS, status })

export const getOneReviewAction = id => ({ type: types.GET_ONE_REVIEW, id })
export const getOneReviewPendingAction = () => ({ type: types.FETCH_ONE_REVIEW_PENDING })
export const getOneReviewFulfilledAction = review => ({
  type: types.FETCH_ONE_REVIEW_FULFILLED,
  payload: { review },
}) // eslint-disable-line
export const getOneReviewRejectedAction = error => ({
  type: types.FETCH_ONE_REVIEW_REJECTED,
  error,
}) // eslint-disable-line

export const deleteReviewAction = id => ({ type: types.DELETE_REVIEW, id })
export const deleteReviewPendingAction = () => ({ type: types.DELETE_REVIEW_PENDING })
export const deleteReviewFulfilledAction = () => ({
  type: types.DELETE_REVIEW_FULFILLED,
  payload: {},
}) // eslint-disable-line
export const deleteReviewRejectedAction = error => ({ type: types.DELETE_REVIEW_REJECTED, error }) // eslint-disable-line
